import { ProductCode } from './product.model';
import { SlotCode } from './slot.model';

export const productToSlotMapping: Partial<Record<ProductCode, SlotCode>> = {
  [ProductCode.JOBSOFFER22S]: SlotCode.JobsBasic,
  [ProductCode.JOBSOFFER22M]: SlotCode.JobsAdvanced,
  [ProductCode.JOBSOFFER22L]: SlotCode.JobsUltimate,
  [ProductCode.JOBSOFFER22XL]: SlotCode.JobsUltimatePlus,
  [ProductCode.JOBUP24BASIC]: SlotCode.JobupBasic,
  [ProductCode.JOBUP24ADVANCED]: SlotCode.JobupAdvanced,
  [ProductCode.JOBUP24ULTIMATE]: SlotCode.JobupUltimate,
  [ProductCode.JOBUP24ULTIMATEPLUS]: SlotCode.JobupUltimatePlus,
};
